export enum NodeConfigTabs {
  NODE_CONFIG = 'node-config',
  BOUNDARY_EVENT_CONFIG = 'boundary-event-config',
  ACTIONS = 'actions',
  RULES = 'rules',
}
